import React from 'react';
import { formStyles as styles } from './styles';

export default function NavigationButtons({
    currentStep,
    handleBack,
    handleNext,
    onCloseModal,
    onSubmit
}) {
    return (
        <div style={styles.navButtonsContainer}>
            {currentStep > 1 && (
                <button type="button" onClick={handleBack}
                    style={styles.buttonBase('#95a5a6', '#7f8c8d')}>
                    <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                    </svg>
                    <span>Quay lại</span>
                </button>
            )}

            <button type="button" onClick={onCloseModal}
                data-dismiss="modal"
                style={styles.buttonBase('#95a5a6', '#7f8c8d')}>
                <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
                <span>Đóng</span>
            </button>

            {currentStep < 3 ? (
                <button type="button" onClick={handleNext}
                    style={styles.buttonBase('#e74c3c', '#c0392b')}>
                    <span>Tiếp tục</span>
                    <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            ) : (
                <button type="button" onClick={onSubmit}
                    data-dismiss="modal"
                    style={styles.buttonBase('#27ae60', '#229954')}>
                    <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Lưu</span>
                </button>
            )}
        </div>
    );
}
